import { from, concatMap } from 'rxjs'
import { getAxiosConfig } from 'fe-common'
import { refreshToken } from '../../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    kycFiles: []
  }),
  actions: {
    getKYCFiles(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/userFiles`,
                {},
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    uploadKYCFile(context, payload) {
      const form = new FormData()

      // append files
      Object.keys(payload.files).map(key => {
        form.append(key, payload.files[key])
      })

      // append params
      form.append('userFilesJsonString', JSON.stringify(payload.params))

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/v3/uploadFileToGoogleCloud`,
                form,
                getAxiosConfig(context, { timeout: 10 * 1000 })
              )
            )
          )
        )
        .toPromise()
    }
  },
  mutations: {
    KYC_FILES(state, payload) {
      state.kycFiles = payload
    }
  },
  getters: {
    kycFiles: state => state.kycFiles
  }
}
